/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Interconectar.API
 * OpenAPI spec version: 1.0
 */

export type Sorted = (typeof Sorted)[keyof typeof Sorted];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Sorted = {
  ASC: "ASC",
  DESC: "DESC",
} as const;
